const ToolboxContentError = () => (
  <div className="text-text-secondary text-center h-full grid place-items-center content-center">
    <p>Something went wrong.</p>
    <p>Check console for errors</p>
  </div>
);

export default ToolboxContentError;
